import process from 'process';
import { Buffer } from 'buffer';

window.process = process;
window.Buffer = Buffer;

import { createApp } from "vue";
import App from "@/App.vue";
import { store } from "./store/store";
import router from "./router";
import mcModel from "@maersk-global/mds-vue-mc-model";
import '@maersk-global/mds-foundations/css/_base-grid.css';
import '@maersk-global/mds-foundations/css/_typography.css';

const app = createApp(App);

window.addEventListener('error', (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        e.stopImmediatePropagation();
    }
});

app.directive("mc-model", mcModel);
app.config.ignoredElements = [/^mc-/];

app.use(store)
app.use(router)
app.mount("#app");

